import SlotFigureOptions from "./SlotFigureOptions";

export default SlotFigureOptions;